import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigation } from '../context/NavigationContext';
import { Screen } from '../types';
import { Button } from '../components/ui/Button';
export function OrderConfirmScreen() {
  const {
    resetTo,
    navigate
  } = useNavigation();
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="min-h-screen bg-white flex flex-col items-center justify-center p-6 text-center" data-id="element-852">
      <motion.div initial={{
      scale: 0
    }} animate={{
      scale: 1
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 15,
      delay: 0.2
    }} className="mb-6 text-success" data-id="element-853">
        <CheckCircle2 className="w-24 h-24" data-id="element-854" />
      </motion.div>

      <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-855">
        Order Placed Successfully!
      </h1>
      <p className="text-gray-500 mb-8" data-id="element-856">
        Your order{' '}
        <span className="font-medium text-gray-900" data-id="element-857">#ORD-847291</span> has been
        placed successfully. You will receive an email confirmation shortly.
      </p>

      <div className="bg-gray-50 rounded-2xl p-4 w-full mb-8 text-left" data-id="element-858">
        <p className="text-sm text-gray-500 mb-1" data-id="element-859">Estimated Delivery</p>
        <p className="font-bold text-gray-900" data-id="element-860">Oct 24 - Oct 26</p>
      </div>

      <div className="w-full space-y-3" data-id="element-861">
        <Button fullWidth onClick={() => navigate(Screen.ORDERS)} data-id="element-862">
          Track Order
        </Button>
        <Button fullWidth variant="outline" onClick={() => resetTo(Screen.HOME)} data-id="element-863">
          Continue Shopping
        </Button>
      </div>
    </motion.div>;
}